import { Link } from "react-router-dom";
import { walletOfOwner } from "../utils/interact";
import { walletOwner } from "../utils/comics";
import React, { useState, useEffect } from "react";
import NFTs from "../_metadata.json";
import Image from "../components/Image";

function Wallet() {
  const [List, setList] = useState([]);
  const [comic, setComic] = useState([]);

  useEffect(() => {
    walletOfOwner().then((data) => {
      setList(data);
    });
    walletOwner().then((data) => {
      setComic(data);
      console.log(data);
    });
  }, []);

  function arrayObjectIndexOf(property, searchTerm) {
    for (var i = 0, len = NFTs.length; i < len; i++) {
      if (NFTs[i][property] === parseInt(searchTerm)) {
        return (
          <article className="image_card" key={i}>
            <Link to={`/details/${searchTerm}`}>
              <Image
                placeholderImg="https://via.placeholder.com/400x200.png?text=This+Will+Be+Shown+Before+Load"
                src={`https://monkeydoonft.online/images/${searchTerm}.png`}
              />
            </Link>
            <div className="card_text">
              <h5>MonkeyDoos #{searchTerm}</h5>
              <h3>Rarity #{NFTs[i]["Rarity_Score"]}</h3>

              <Link to={`/transfer/${searchTerm}`}>
                <button
                  className="btn btn-primary"
                  style={{
                    width: "100%",
                    marginTop: "1rem",
                  }}
                >
                  Transfer NFT
                </button>
              </Link>
            </div>
          </article>
        );
      }
    }
    return null;
  }

  return (
    <section
      className="container project_container"
      id="nftproject"
      style={{
        marginTop: "11rem",
      }}
    >
      <h2>My Wallet</h2>

      <div className="image_cards">
        {List.length > 0 ? (
          List.map((item, i) => {
            return arrayObjectIndexOf("edition", item);
          })
        ) : (
          <div className="center">
            <h5>No NFT in your wallet</h5>
          </div>
        )}
      </div>

      <h2>My Comic</h2>

      <div className="image_cards">
        {comic.length > 0 ? (
          comic.map((item, i) => {
            return (
              <article className="image_card" key={i}>
                <img
                  src={`comic.png`}
                  style={{
                    padding: "15px",
                  }}
                />
                <div className="card_text">
                  <h5>MonkeyDoos Comic #{item}</h5>
                </div>
              </article>
            );
          })
        ) : (
          <div className="center">
            <h5>No NFT in your wallet</h5>
          </div>
        )}
      </div>
    </section>
  );
}

export default Wallet;
